'use strict';

const Header = {
    WebAppVersion: 'Templafy-WebApp-Version',
    CSRF: 'x-csrf-token',
};
const CSRF_TOKEN_COOKIE_NAME = '__Host-Csrf-Token';

exports.CSRF_TOKEN_COOKIE_NAME = CSRF_TOKEN_COOKIE_NAME;
exports.Header = Header;
//# sourceMappingURL=constants.js.map
